import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, profile, loading, getDefaultDashboard } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!profile || (profile.role !== 'admin' && profile.role !== 'super_admin')) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <h1>Access Denied</h1>
        <p>You need admin privileges to access this page.</p>
        <a href={`/${getDefaultDashboard()}`} style={{ color: '#007bff' }}>
          Return to Dashboard
        </a>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
